import { Box, Container, Grid, Typography, Link } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import { SectionHeading } from '@/components/common'
import { ContactForm } from './ContactForm'
import { SECTION_IDS, CONTACT_INFO } from '@/utils/constants'

/**
 * Contact Section Component
 * Complete contact section with form and contact information
 */
export const ContactSection = () => {
  return (
    <Box
      component="section"
      id={SECTION_IDS.CONTACT}
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          Get In Touch
        </SectionHeading>

        <Grid container spacing={{ xs: 4, md: 6 }}>
          {/* Contact Form */}
          <Grid item xs={12} md={7}>
            <ContactForm />
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                p: { xs: 3, md: 4 },
                bgcolor: 'grey.100',
                borderRadius: 2,
                height: '100%',
              }}
            >
              <Typography
                variant="h5"
                component="h3"
                sx={{
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Contact Information
              </Typography>

              {/* Email */}
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  mb: 3,
                }}
              >
                <EmailIcon color="primary" />
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                    }}
                  >
                    Email
                  </Typography>
                  <Link
                    href={`mailto:${CONTACT_INFO.EMAIL}`}
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      '&:hover': {
                        color: 'primary.main',
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    {CONTACT_INFO.EMAIL}
                  </Link>
                </Box>
              </Box>

              {/* Phone */}
              {/* <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  mb: 3,
                }}
              >
                <PhoneIcon color="primary" />
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                    }}
                  >
                    Phone
                  </Typography>
                  <Link
                    href={`tel:${CONTACT_INFO.PHONE}`}
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      '&:hover': {
                        color: 'primary.main',
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    {CONTACT_INFO.PHONE}
                  </Link>
                </Box>
              </Box> */}

              {/* Business Hours */}
              {/* <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                }}
              >
                <AccessTimeIcon color="primary" />
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                    }}
                  >
                    Business Hours
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {CONTACT_INFO.BUSINESS_HOURS}
                  </Typography>
                </Box>
              </Box> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
